import { RoutesList } from '@bikes/routes/Routes';
import { useBikesStore } from '@bikes/store/store';
import { ContentBodyList } from '@molecules/*';
import { TextAreaTemplate } from '@templates';
import { ErrorMessages } from '@types';
import {
  parseZodErrors,
  TextAreaFlexibleLengthSchema,
  TextAreaFlexibleLengthSchemaType,
  TextAreaMaxLengthSchema,
} from '@utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ZodError } from 'zod';

export const TellUsMorePage = () => {
  const { updateTellUsMoreText, tellUsMoreText, bikesType, obstructionType } =
    useBikesStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const context = bikesType === 'hire_scooters' ? 'scooters' : 'bikes';
  const mandatoryAnswer =
    obstructionType === 'SomethingElse' || bikesType === 'bikes';
  const pageTitle = `Tell us more about the problem ${!mandatoryAnswer ? '(optional)' : ''}`;
  const errorPath = 'tellUsMoreText';
  const hireDescription = `Add further details on the location, type of issue, or the number of ${context} you're reporting.`;
  const isPersonalBike = bikesType === 'bikes';

  const PersonalBikeDescription = {
    title: `We need to know:`,
    itemList: [
      `if it's a whole bike, part of a bike or a lock`,
      `the bike's brand`,
      `the bike's colour`,
      `any more details on the bike's location`,
    ],
  };

  const description = isPersonalBike ? (
    <div className="text-bodyLg flex flex-col space-y-3">
      <ContentBodyList
        itemList={PersonalBikeDescription.itemList}
        title={PersonalBikeDescription.title}
      />
    </div>
  ) : (
    hireDescription
  );

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (errorMessages.length > 0) {
      setErrorMessages([]);
    }
    updateTellUsMoreText(event.target.value);
  };

  const handleNextClick = () => {
    let validation = {
      fieldNames: ['tellUsMoreText'],
      maxLength: MAX_LENGTH,
    };

    try {
      if (mandatoryAnswer) {
        // Check both the min and max value if mandatory answer is required
        validation = {
          ...validation,
        } as TextAreaFlexibleLengthSchemaType;
        TextAreaFlexibleLengthSchema(validation).parse({
          tellUsMoreText,
        });
      } else {
        // Otherwise only checks if text goes over MAX_LENGTH
        TextAreaMaxLengthSchema(validation).parse({ tellUsMoreText });
      }

      navigate(RoutesList.EMAIL_CONFIRMATION_REPORT);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
        })),
      );
    }
  };

  const handlePreviousClick = () => {
    if (bikesType === 'bikes') {
      navigate(RoutesList.BIKES_LOCATION);
      return;
    } else {
      navigate(RoutesList.WHAT_IS_ISSUE);
    }
  };

  const buttonNext = {
    onClick: handleNextClick,
  };

  const buttonPrevious = {
    onClick: handlePreviousClick,
  };

  return (
    <TextAreaTemplate
      initialTextValue={tellUsMoreText}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
